import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=7ea0cba2&"
import script from "./loader.vue?vue&type=script&lang=ts&"
export * from "./loader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\references\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ea0cba2')) {
      api.createRecord('7ea0cba2', component.options)
    } else {
      api.reload('7ea0cba2', component.options)
    }
    module.hot.accept("./loader.vue?vue&type=template&id=7ea0cba2&", function () {
      api.rerender('7ea0cba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loader/loader.vue"
export default component.exports